module.exports = __webpack_public_path__ + "static/LibreFranklin-LightItalic-6a10b53cbf1addc6be56415e4a280432.ttf";